webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(274)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(1088),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1078:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "day"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.day.date, 'dd. Do MMM ')))]), _c('div', {
    staticClass: "events"
  }, _vm._l((_vm.day.events), function(event) {
    return _c('div', {
      staticClass: "event"
    }, [_c('dl', [_c('dt', [_vm._v(_vm._s(event.badge))]), _c('dd', [_vm._v(_vm._s(_vm._f("moment")(event.start, 'HH:mm')) + " - " + _vm._s(event.name))])])])
  }), 0), _c('span', {
    staticClass: "bold"
  }, [_vm._v("PAX:")]), _c('span', [_vm._v(" " + _vm._s(_vm.day.pax))]), (_vm.day.sold_out) ? _c('span', {
    staticClass: "bold"
  }, [_vm._v(" ausverkauft!")]) : _vm._e(), _c('div', [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ende VA ca.:")]), (_vm.day.planned_end) ? _c('span', [_vm._v(" " + _vm._s(_vm.day.planned_end.split(':').slice(0, 2).join(':')) + " Uhr")]) : _c('span', [_vm._v(" -")])]), (_vm.day.production_managers.length > 0) ? _c('div', {
    staticClass: "production-managers"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PL:  ")]), _vm._l((_vm.day.production_managers), function(manager) {
    return _c('span', {
      staticClass: "manager"
    }, [_vm._v(_vm._s(manager))])
  })], 2) : _vm._e(), (_vm.day.day_managers.length > 0) ? _c('div', {
    staticClass: "day-managers"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TL:  ")]), _vm._l((_vm.day.day_managers), function(manager) {
    return _c('span', {
      staticClass: "manager"
    }, [_vm._v(_vm._s(manager))])
  })], 2) : _vm._e(), (_vm.day.managers.length > 0) ? _c('div', {
    staticClass: "managers"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("AL:  ")]), _vm._l((_vm.day.managers), function(manager) {
    return _c('span', {
      staticClass: "manager"
    }, [_vm._v(_vm._s(manager))])
  })], 2) : _vm._e(), (_vm.day.schedule && _vm.day.schedule !== '') ? _c('div', {
    staticClass: "schedule"
  }, [_c('h3', [_vm._v("Tagesablauf")]), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$options.filters.linebreaks(_vm.day.schedule))
    }
  })]) : _vm._e(), (_vm.day.documents.length > 0) ? _c('div', {
    staticClass: "documents"
  }, [_c('h3', [_vm._v("Dokumente")]), _c('ul', {
    staticClass: "files"
  }, _vm._l((_vm.day.documents), function(doc) {
    return _c('li', [_c('a', {
      attrs: {
        "href": doc.url,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa",
      class: doc.icon
    }), _vm._v(" " + _vm._s(doc.name))])])
  }), 0)]) : _vm._e(), _vm._l((_vm.day.shifts), function(shift, index) {
    return _c('shift', {
      key: shift.id,
      class: {
        'gray': index % 2 === 0
      },
      attrs: {
        "shift": shift
      }
    })
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1079:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employees-list"
  }, _vm._l((_vm.fields), function(field) {
    return _c('div', {
      staticClass: "field"
    }, [_c('h3', [_vm._v(_vm._s(field.name))]), _vm._l((_vm.employees[field.name]), function(employee) {
      return _c('div', {
        key: employee.id,
        staticClass: "employee"
      }, [_c('span', {
        staticClass: "name"
      }, [(_vm.user.is_superuser) ? _c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.loginAs(employee.id)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-eye"
      })]) : _vm._e(), _vm._v(" " + _vm._s(employee.short_name))]), _c('span', {
        staticClass: "cell-phone"
      }, [_c('a', {
        attrs: {
          "href": 'tel:' + employee.cell_phone
        }
      }, [_vm._v(_vm._s(employee.cell_phone))])]), _c('span', {
        staticClass: "email"
      }, [_c('a', {
        attrs: {
          "href": 'mailto:' + employee.email
        }
      }, [_c('i', {
        staticClass: "fa fa-envelope"
      })])])])
    })], 2)
  }), 0)
},staticRenderFns: []}

/***/ }),

/***/ 1080:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "days"
  }, [_vm._l((_vm.days), function(day, index) {
    return _c('div', {
      staticClass: "day",
      class: {
        'gray': index % 2 === 0, 'is-today': day.is_today === true
      }
    }, [_c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("moment")(day.date, 'dd. Do MMM ')))]), _c('div', {
      staticClass: "events"
    }, _vm._l((day.events), function(event) {
      return _c('div', {
        staticClass: "event"
      }, [_c('dl', [_c('dt', [_vm._v(_vm._s(event.badge))]), _c('dd', [_vm._v(_vm._s(_vm._f("moment")(event.start, 'HH:mm')) + " - " + _vm._s(event.name))])])])
    }), 0), (day.production_managers.length > 0) ? _c('div', {
      staticClass: "production-managers"
    }, [_c('span', {
      staticClass: "manager-label"
    }, [_vm._v("PL:  ")]), _vm._l((day.production_managers), function(manager) {
      return _c('span', {
        staticClass: "manager"
      }, [_vm._v(_vm._s(manager))])
    })], 2) : _vm._e(), (day.day_managers.length > 0) ? _c('div', {
      staticClass: "day-managers"
    }, [_c('span', {
      staticClass: "manager-label"
    }, [_vm._v("TL:  ")]), _vm._l((day.day_managers), function(manager) {
      return _c('span', {
        staticClass: "manager"
      }, [_vm._v(_vm._s(manager))])
    })], 2) : _vm._e(), (day.managers.length > 0) ? _c('div', {
      staticClass: "managers"
    }, [_c('span', {
      staticClass: "manager-label"
    }, [_vm._v("AL:  ")]), _vm._l((day.managers), function(manager) {
      return _c('span', {
        staticClass: "manager"
      }, [_vm._v(_vm._s(manager))])
    })], 2) : _vm._e(), _vm._l((day.my_shifts), function(shift, index) {
      return _c('shift', {
        key: shift.id,
        class: {
          'gray': index % 2 === 0
        },
        attrs: {
          "shift": shift
        }
      })
    }), (day.other_shifts.length > 0 || day.documents.length > 0 || (day.schedule && day.schedule !== '')) ? _c('div', {
      staticClass: "field"
    }, [_c('div', {
      staticClass: "button-div"
    }, [_c('a', {
      staticClass: "button",
      on: {
        "click": function($event) {
          return _vm.toggleOtherShifts(day)
        }
      }
    }, [_vm._v("Tagesübersicht")])]), (day.schedule && day.schedule !== '') ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (day.show_others),
        expression: "day.show_others"
      }],
      staticClass: "schedule"
    }, [_c('h3', [_vm._v("Tagesablauf")]), _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.$options.filters.linebreaks(day.schedule))
      }
    })]) : _vm._e(), (day.documents.length > 0) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (day.show_others),
        expression: "day.show_others"
      }],
      staticClass: "documents"
    }, [_c('h3', [_vm._v("Dokumente")]), _c('ul', {
      staticClass: "files"
    }, _vm._l((day.documents), function(doc) {
      return _c('li', [_c('a', {
        attrs: {
          "href": doc.url,
          "target": "_blank"
        }
      }, [_c('i', {
        staticClass: "fa",
        class: doc.icon
      }), _vm._v(" " + _vm._s(doc.name))])])
    }), 0)]) : _vm._e(), (day.show_others) ? _c('div', {
      staticClass: "other-shifts"
    }, _vm._l((day.other_shifts), function(shift, index) {
      return _c('shift', {
        key: shift.id,
        class: {
          'gray': index % 2 === 0
        },
        attrs: {
          "shift": shift
        }
      })
    }), 1) : _vm._e()]) : _vm._e()], 2)
  }), (_vm.days.length == 0) ? _c('div', [_c('br'), _c('br'), _c('span', [_vm._v("Du bist aktuell keiner Schicht zugeteilt!")]), _c('br'), _c('br'), (_vm.user.can_apply_for_shifts) ? _c('span', [_vm._v("Checke Deine")]) : _vm._e(), _c('br')]) : _vm._e(), (_vm.user.can_apply_for_shifts) ? _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.switchToApplications()
      }
    }
  }, [_vm._v("Bewerbungen")]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1081:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.shift.shift_times.length > 0 || _vm.shift.can_add) ? _c('div', {
    staticClass: "presence-list"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.shift.shift_type))]), _vm._v(" (" + _vm._s(_vm._f("moment")([_vm.shift.start, "HH:mm:ss"], 'HH:mm')) + " Uhr)")]), _vm._l((_vm.shift.shift_times), function(entry) {
    return _c('presence-entry', {
      key: entry.id,
      attrs: {
        "shift-time": entry,
        "user": _vm.user
      },
      on: {
        "refresh": function($event) {
          return _vm.$emit('refresh')
        }
      }
    })
  }), (_vm.shift.can_add && _vm.user.can_record_shift_times) ? _c('vue-autosuggest', {
    ref: "addEmployee",
    staticClass: "addButton",
    class: {
      'confirmationPending': _vm.selected
    },
    attrs: {
      "suggestions": _vm.filteredOptions,
      "input-props": _vm.inputProps,
      "getSuggestionValue": _vm.getValue
    },
    on: {
      "input": _vm.onInputChange,
      "selected": _vm.onSelected,
      "focus": function($event) {
        return _vm.getEmployeeList()
      },
      "click": _vm.clickHandler,
      "closed": function($event) {
        return _vm.clearLetters()
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var suggestion = ref.suggestion;

        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.bolden(_vm.query, suggestion.item.short_name))
          }
        })]
      }
    }], null, false, 2850676057),
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  }) : _vm._e(), (_vm.selected) ? _c('span', [_c('button', {
    on: {
      "click": function($event) {
        return _vm.confirmSelection()
      }
    }
  }, [_vm._v("JA")]), _c('button', {
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_vm._v("Abbrechen")])]) : _vm._e()], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1082:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vacations"
  }, [_c('div', [_vm._v("Dein Urlaubsanspruch: " + _vm._s(_vm.vacationData.vacation_days))]), _c('div', [_vm._v("Bereits in Anspruch genommen: " + _vm._s(_vm.vacationData.used_vacation_days_till_today))]), _c('div', [_vm._v("Geplante Urlaubstage: " + _vm._s(_vm.vacationData.planned_vacation_days))]), _c('div', [_vm._v("Resturlaub (heute): " + _vm._s(_vm.vacationData.open_vacation_days))]), _vm._m(0), _c('form', [_c('label', [_vm._v("Von:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_vacation.start),
      expression: "new_vacation.start"
    }],
    attrs: {
      "type": "date",
      "name": "start",
      "required": "required"
    },
    domProps: {
      "value": (_vm.new_vacation.start)
    },
    on: {
      "change": _vm.setEnd,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.new_vacation, "start", $event.target.value)
      }
    }
  }), _c('label', [_vm._v("Bis:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_vacation.end),
      expression: "new_vacation.end"
    }],
    attrs: {
      "type": "date",
      "name": "end",
      "required": "required"
    },
    domProps: {
      "value": (_vm.new_vacation.end)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.new_vacation, "end", $event.target.value)
      }
    }
  }), _c('br'), (_vm.error) ? _c('div', [_c('br'), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _c('br'), _c('button', {
    on: {
      "click": _vm.submitVacation
    }
  }, [_vm._v("Urlaub Beantragen")])]), _c('div', [_c('strong', [_vm._v("Eingereichte Urlaube")]), _vm._l((_vm.vacations), function(vacation) {
    return _c('vacation', {
      key: vacation.id,
      attrs: {
        "vacation": vacation,
        "user": _vm.user
      },
      on: {
        "reload-vacations": function($event) {
          _vm.$emit('reload-vacations');
          _vm.loadVacationData()
        }
      }
    })
  }), (_vm.vacations.length == 0) ? _c('div', [_vm._v("keine")]) : _vm._e()], 2), _c('div', [_c('strong', {
    staticClass: "otherVacations",
    class: {
      'visible': _vm.showOtherVacations
    },
    on: {
      "click": function($event) {
        _vm.showOtherVacations = !_vm.showOtherVacations
      }
    }
  }, [_vm._v("Urlaub in meinen Gewerken")])]), (_vm.showOtherVacations) ? _c('div', [_vm._l((_vm.otherVacations), function(vacation) {
    return _c('dl', {
      key: vacation.id,
      staticClass: "vacation"
    }, [_c('dt', {
      class: vacation.status
    }, [_vm._v("Von " + _vm._s(_vm._f("moment")(vacation.start, 'DD.MM.YYYY')))]), _c('dd', [_vm._v("bis " + _vm._s(_vm._f("moment")(vacation.end, 'DD.MM.YYYY')) + " - " + _vm._s(vacation.name))])])
  }), (_vm.otherVacations.length == 0) ? _c('span', [_vm._v("keine")]) : _vm._e()], 2) : _vm._e(), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('strong', [_vm._v("Neuen Urlaub einreichen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('strong', [_vm._v("Legende")]), _c('dl', {
    staticClass: "legend"
  }, [_c('dt', {
    staticClass: "new"
  }, [_vm._v(" ")]), _c('dd', [_vm._v("Unbearbeitet")])]), _c('dl', {
    staticClass: "legend"
  }, [_c('dt', {
    staticClass: "accepted"
  }, [_vm._v(" ")]), _c('dd', [_vm._v("Genehmigt")])]), _c('dl', {
    staticClass: "legend"
  }, [_c('dt', {
    staticClass: "denied"
  }, [_vm._v(" ")]), _c('dd', [_vm._v("Abgelehnt")])])])
}]}

/***/ }),

/***/ 1083:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "app",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    on: {
      "login-as": _vm.loginAs
    }
  }), (_vm.loggedIn) ? _c('div', {
    staticClass: "links"
  }, [(_vm.user.can_see_guestlist) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.displayGuestList($event)
      }
    }
  }, [_c('span', [_vm._v("GL")]), _c('i', {
    staticClass: "fa fa-calendar-check-o"
  })]) : _vm._e(), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.displayVacations($event)
      }
    }
  }, [_c('span', [_vm._v("Urlaub")]), _c('i', {
    staticClass: "fa fa-plane"
  })]), (_vm.user.can_view_shift_plan) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.displayShiftPlan($event)
      }
    }
  }, [_c('span', [_vm._v("Schichten")]), _c('i', {
    staticClass: "fa fa-calendar"
  })]) : _vm._e(), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showEmployeeList = true
      }
    }
  }, [_c('span', [_vm._v("Team")]), _c('i', {
    staticClass: "fa fa-users"
  })]), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.loadNews()
      }
    }
  }, [_c('span', [_vm._v("News")]), _c('i', {
    staticClass: "fa fa-newspaper-o"
  })]), _c('a', {
    staticStyle: {
      "margin-right": "17px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_c('span'), _c('i', {
    staticClass: "fa fa-sign-out"
  })])]) : _vm._e(), (!_vm.loggedIn) ? _c('form', {
    staticClass: "loginForm"
  }, [_c('div', {
    staticClass: "section"
  }, [_vm._m(0), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "input",
    attrs: {
      "name": "username",
      "placeholder": "eMail"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _c('i', {
    staticClass: "fa fa-user"
  })]), _c('p', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "Passwort"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.logMeIn($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _c('i', {
    staticClass: "fa fa-key fa-rotate-90"
  })])])]), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "DGSVO"
    },
    on: {
      "click": function($event) {
        _vm.confirmed = !_vm.confirmed
      }
    }
  }), _c('label', {
    attrs: {
      "for": "DGSVO"
    }
  }, [_vm._v(" Ich akzeptiere die "), _c('a', {
    attrs: {
      "href": this.$root.apiHost + '/datenschutz'
    }
  }, [_vm._v("Datenschutzregelungen")])]), _c('br'), _c('br'), _c('a', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.confirmed
    },
    on: {
      "click": _vm.logMeIn
    }
  }, [_vm._v("einloggen")])])])])]) : _vm._e(), (_vm.loggedIn) ? _c('div', {
    staticClass: "section"
  }, [_c('b-aside', {
    staticClass: "presence",
    attrs: {
      "is-show": _vm.editShiftTimes,
      "title": "Anwesenheiten",
      "show-footer": false,
      "placement": "right"
    },
    on: {
      "close": function($event) {
        _vm.editShiftTimes = false
      }
    }
  }, [(_vm.editShiftTimes) ? _c('presence-panel', {
    attrs: {
      "user": _vm.user
    }
  }) : _vm._e()], 1), _c('b-aside', {
    attrs: {
      "is-show": _vm.showApplications,
      "title": "Bewerbungen",
      "show-footer": false
    },
    on: {
      "close": function($event) {
        _vm.showApplications = false
      }
    }
  }, [_c('applications')], 1), _c('b-aside', {
    attrs: {
      "is-show": _vm.showVacations,
      "title": "Urlaub",
      "show-footer": false
    },
    on: {
      "close": function($event) {
        _vm.showVacations = false
      }
    }
  }, [_c('vacations', {
    attrs: {
      "vacations": _vm.vacations,
      "user": _vm.user
    },
    on: {
      "reload-vacations": _vm.loadVacations
    }
  })], 1), _c('b-aside', {
    attrs: {
      "is-show": _vm.showNews,
      "title": "News",
      "show-footer": false
    },
    on: {
      "close": function($event) {
        _vm.showNews = false
      }
    }
  }, [_c('div', [_vm._v("Hier findest du News vom KA, Deli und aus den Gewerken.")]), _c('br'), _vm._l((_vm.news), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "newsItem"
    }, [_c('div', {
      staticClass: "headline"
    }, [_c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("moment")(new Date(item.created), 'dd. Do MMM ')))]), _c('div', {
      staticClass: "newsType"
    }, [_vm._v(_vm._s(item.type_display))])]), _c('h2', [_vm._v(_vm._s(item.title))]), (item.showContent) ? _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), (item.attachments.length > 0) ? _c('div', {
      staticClass: "attachments"
    }, [_c('b', [_vm._v("Anhänge:")]), _c('ul', _vm._l((item.attachments), function(att) {
      return _c('li', {
        key: att.id
      }, [_c('a', {
        attrs: {
          "href": _vm.apiUrl + att.file,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(att.name))])])
    }), 0)]) : _vm._e()]) : _vm._e(), _c('div', {
      staticClass: "buttons"
    }, [_c('a', {
      staticClass: "button",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          item.showContent = !item.showContent
        }
      }
    }, [_vm._v(_vm._s(item.showContent ? 'Ausblenden' : 'Anzeigen'))])])])
  })], 2), _c('b-aside', {
    attrs: {
      "is-show": _vm.showGuestList,
      "title": "Gästeliste",
      "show-footer": false
    },
    on: {
      "close": function($event) {
        _vm.showGuestList = false
      }
    }
  }, [(!_vm.currentEvent) ? _c('div', [_vm._v("Heute keine Veranstaltung.")]) : _vm._e(), (_vm.currentEvent) ? _c('div', [_c('div', [_c('b', [_vm._v("VA: ")]), _vm._v(_vm._s(_vm.currentEvent.name))]), _c('br'), _c('div', {
    staticClass: "search-bar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.guestSearch),
      expression: "guestSearch"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Gast suchen ..."
    },
    domProps: {
      "value": (_vm.guestSearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.guestSearch = $event.target.value
      }
    }
  }), _c('i', {
    staticClass: "fa fa-times",
    on: {
      "click": function($event) {
        _vm.guestSearch = ''
      }
    }
  })]), _c('br'), _c('div', {
    staticClass: "legend"
  }, [_c('span', {
    staticClass: "so36",
    class: {
      inactive: _vm.catSearch != 'so36' && _vm.catSearch != ''
    },
    on: {
      "click": function($event) {
        return _vm.setCatSearch('so36')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-beer"
  }), _c('span', [_vm._v("SO36")])]), _c('span', {
    staticClass: "band",
    class: {
      inactive: _vm.catSearch != 'band' && _vm.catSearch != ''
    },
    on: {
      "click": function($event) {
        return _vm.setCatSearch('band')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-music"
  }), _vm._v("Band")]), _c('span', {
    staticClass: "agency",
    class: {
      inactive: _vm.catSearch != 'agency' && _vm.catSearch != ''
    },
    on: {
      "click": function($event) {
        return _vm.setCatSearch('agency')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  }), _c('span', [_vm._v("Agentur")])]), _c('span', {
    staticClass: "win",
    class: {
      inactive: _vm.catSearch != 'win' && _vm.catSearch != ''
    },
    on: {
      "click": function($event) {
        return _vm.setCatSearch('win')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trophy"
  }), _c('span', [_vm._v("Gewinnspiel")])])]), _c('br'), _c('div', {
    staticClass: "guest"
  }, [_c('div', {
    staticClass: "info head"
  }, [_c('span', [_vm._v("Kat.")]), _c('span', [_vm._v("Name")]), _c('span', [_vm._v("+X")]), _c('span', [_vm._v("Bänd.")]), _c('span', [_vm._v("Anw.")])]), _c('div', {
    staticClass: "comment"
  }, [_c('span')])]), _vm._l((_vm.filteredGuests), function(guest) {
    return _c('div', {
      staticClass: "guest",
      class: {
        selected: _vm.selectedGuest && _vm.selectedGuest.id == guest.id
      }
    }, [_c('div', {
      staticClass: "info",
      on: {
        "click": function($event) {
          return _vm.selectGuest(guest)
        }
      }
    }, [_c('span', {
      class: guest.category
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.icons[guest.category]
    })]), _c('span', [_vm._v(_vm._s(guest.name))]), _c('span', [_vm._v(_vm._s(guest.plus_x > 0 ? '+' + guest.plus_x : '—'))]), _c('span', [_vm._v(_vm._s(guest.ribbon ? '✔️' : '✖'))]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (guest.present),
        expression: "guest.present"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(guest.present) ? _vm._i(guest.present, null) > -1 : (guest.present)
      },
      on: {
        "change": [function($event) {
          var $$a = guest.present,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(guest, "present", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(guest, "present", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(guest, "present", $$c)
          }
        }, function($event) {
          return _vm.updateGuest(guest)
        }],
        "click": [function($event) {
          $event.stopPropagation();
          return true($event)
        }, function($event) {
          _vm.selectedGuest = guest
        }]
      }
    })]), (_vm.selectedGuest && _vm.selectedGuest.id == guest.id && guest.comment != '') ? _c('div', {
      staticClass: "comment"
    }, [_c('span', [_c('b', [_vm._v("Kommentar: ")]), _vm._v(_vm._s(guest.comment))])]) : _vm._e()])
  })], 2) : _vm._e()]), (_vm.user.can_view_shift_plan || _vm.user.is_admin) ? _c('b-aside', {
    staticClass: "plan",
    attrs: {
      "is-show": _vm.showShiftPlan,
      "title": "Schichtplan",
      "show-footer": false,
      "placement": "right"
    },
    on: {
      "close": function($event) {
        _vm.showShiftPlan = false
      }
    }
  }, [_c('div', {
    staticClass: "selection"
  }, [(_vm.canViewAll) ? _c('ul', {
    staticClass: "fields"
  }, [_c('li', {
    class: {
      active: !_vm.fieldFilter
    },
    on: {
      "click": function($event) {
        return _vm.getPlannedDays(null)
      }
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.getPlannedDays(null)
      }
    }
  }, [_vm._v("Alle")])]), _vm._l((_vm.fields), function(field) {
    return (field.show_shifts) ? _c('li', {
      class: {
        active: field.id === _vm.fieldFilter
      }
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.getPlannedDays(field.id)
        }
      }
    }, [_vm._v(_vm._s(field.name))])]) : _vm._e()
  })], 2) : _vm._e()]), _c('div', {
    staticClass: "plan"
  }, [_vm._l((_vm.plannedDays), function(day, index) {
    return [(day.is_today) ? _c('a', {
      attrs: {
        "id": "plan-starts-today"
      }
    }) : _vm._e(), _c('planned-day', {
      class: {
        'gray': index % 2 === 0, 'is-today': day.is_today === true
      },
      attrs: {
        "day": day
      }
    })]
  })], 2)]) : _vm._e(), _c('b-aside', {
    staticClass: "employees",
    attrs: {
      "is-show": _vm.showEmployeeList,
      "title": "Team",
      "show-footer": false,
      "placement": "right"
    },
    on: {
      "close": function($event) {
        _vm.showEmployeeList = false
      }
    }
  }, [_c('employees-list', {
    attrs: {
      "fields": _vm.fields,
      "user": _vm.user
    },
    on: {
      "login-as": _vm.loginAs
    }
  })], 1), (_vm.user.can_record_shift_times) ? _c('div', {
    staticClass: "presence"
  }, [_c('div', {
    staticClass: "button yellowbg",
    on: {
      "click": function($event) {
        _vm.editShiftTimes = true
      }
    }
  }, [_vm._v("Anwesenheiten erfassen")]), _c('br'), _c('br')]) : _vm._e(), (_vm.user.can_view_shift_times && !_vm.user.can_record_shift_times) ? _c('div', {
    staticClass: "presence"
  }, [_c('div', {
    staticClass: "button yellowbg",
    on: {
      "click": function($event) {
        _vm.editShiftTimes = true
      }
    }
  }, [_vm._v("Anwesenheiten einsehen")]), _c('br'), _c('br')]) : _vm._e(), _c('span', [_vm._v("Hi " + _vm._s(_vm.user.short_name) + "! Hier sind Deine kommenden Schichten:")]), _c('shifts', {
    attrs: {
      "switchToApplications": _vm.switchToApplications,
      "user": _vm.user
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._v("Bitte logge Dich ein, um Deine aktuellen Schichten zu sehen."), _c('br'), _vm._v("Falls Du dein Passwort vergessen hast, oder Dich zum ersten\nMal hier anmelden willst, bitte "), _c('a', {
    attrs: {
      "href": "https://salat.pepperz.de/admin-tools/password_reset/",
      "target": "_blank"
    }
  }, [_vm._v("hier entlang")]), _vm._v(".")])])
}]}

/***/ }),

/***/ 1084:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "applications"
  }, [_c('p', [_vm._v("Entscheide Dich zeitnah, bei welchen Schichten Du arbeiten möchtest.\nWenn der Schichtplan fertig ist, bekommst Du eine Mail.")]), _c('ul', _vm._l((_vm.days), function(day, index) {
    return _c('li', {
      staticClass: "day",
      class: {
        'gray': index % 2 === 0
      }
    }, [_c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("moment")(day.date, 'dd. Do MMM ')))]), _c('div', {
      staticClass: "events"
    }, _vm._l((day.events), function(event) {
      return _c('div', {
        staticClass: "event"
      }, [_c('dl', [_c('dt', [_vm._v(_vm._s(event.badge))]), _c('dd', [_vm._v(_vm._s(_vm._f("moment")(event.start, 'HH:mm')) + " - " + _vm._s(event.name))])])])
    }), 0), _vm._l((day.applications), function(application) {
      return _c('div', {
        staticClass: "application"
      }, [_c('application', {
        attrs: {
          "application": application
        }
      })], 1)
    })], 2)
  }), 0)])
},staticRenderFns: []}

/***/ }),

/***/ 1085:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.shiftCanceled) ? _c('div', {
    staticClass: "shift"
  }, [_c('div', {
    staticClass: "shift-name"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.shift.real_start, 'HH:mm')) + " - ")]), _c('strong', {
    staticClass: "type"
  }, [_vm._v(_vm._s(_vm.shift.shift_type))])]), (_vm.shift.shift_manager) ? _c('div', {
    staticClass: "manager"
  }, [_c('strong', [_vm._v("AL: " + _vm._s(_vm.shift.shift_manager))])]) : _vm._e(), _c('div', {
    staticClass: "employees"
  }, _vm._l((_vm.shift.employees), function(employee) {
    return _c('span', {
      staticClass: "employee"
    }, [_vm._v(_vm._s(employee))])
  }), 0), (_vm.shift.comments !== '') ? _c('div', {
    staticClass: "comments",
    domProps: {
      "innerHTML": _vm._s(_vm.$options.filters.linebreaks(_vm.shift.comments))
    }
  }) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "presence-user"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.shiftTime.username))]), _c('div', {
    staticClass: "item"
  }, [(!_vm.shiftTime.start && _vm.user.can_record_shift_times) ? _c('div', {
    staticClass: "button yellow",
    on: {
      "click": _vm.checkin
    }
  }, [_vm._v("check in")]) : _vm._e(), (_vm.shiftTime.start) ? _c('div', {
    staticClass: "time"
  }, [(!_vm.shiftTime.end && _vm.user.can_record_shift_times) ? _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.subtract('start', true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  })]) : _vm._e(), (!_vm.shiftTime.end && _vm.user.can_record_shift_times) ? _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.add('start', true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-up"
  })]) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm.shiftTime.start))]), ((!_vm.shiftTime.end && _vm.user.can_record_shift_times) || _vm.user.is_board_member) ? _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.subtract('start')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  })]) : _vm._e(), ((!_vm.shiftTime.end && _vm.user.can_record_shift_times) || _vm.user.is_board_member) ? _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.add('start')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-up"
  })]) : _vm._e()]) : _vm._e()]), (_vm.shiftTime.start) ? _c('div', {
    staticClass: "item"
  }, [(!_vm.shiftTime.end && _vm.user.can_record_shift_times) ? _c('div', {
    staticClass: "button green",
    on: {
      "click": _vm.checkout
    }
  }, [_vm._v("check out")]) : _vm._e(), (_vm.shiftTime.end) ? _c('div', {
    staticClass: "time"
  }, [_c('span', [_vm._v(_vm._s(_vm.shiftTime.end))]), (_vm.user.can_record_shift_times) ? _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.subtract('end')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  })]) : _vm._e(), (_vm.user.can_record_shift_times) ? _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.add('end')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-up"
  })]) : _vm._e()]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1087:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "vacation"
  }, [_c('dt', {
    class: _vm.vacation.status
  }, [_vm._v("Von " + _vm._s(_vm._f("moment")(_vm.vacation.start, 'DD.MM.YYYY')))]), _c('dd', [_vm._v("bis " + _vm._s(_vm._f("moment")(_vm.vacation.end, 'DD.MM.YYYY')) + " - Tage: " + _vm._s(_vm.vacation.used_days))]), (_vm.canDeleteVacation) ? _c('a', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.showConfirmation = true
      }
    }
  }) : _vm._e(), (_vm.showConfirmation) ? _c('div', {
    staticClass: "confirmation"
  }, [_vm._v("Diesen Urlaub wirklich löschen?  "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showConfirmation = false
      }
    }
  }, [_vm._v("nein")]), _c('button', {
    on: {
      "click": _vm.deleteVacation
    }
  }, [_vm._v("ja")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.klass,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path, i) {
    return _c('path', _vm._b({
      key: ("path-" + i)
    }, 'path', path, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon, i) {
    return _c('polygon', _vm._b({
      key: ("polygon-" + i)
    }, 'polygon', polygon, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1089:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "application"
  }, [_c('div', {
    staticClass: "time"
  }), _c('div', {
    staticClass: "shift-name"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("moment")(_vm.application.shift.real_start, 'HH:mm')) + " - ")]), _c('strong', {
    staticClass: "type"
  }, [_vm._v(_vm._s(_vm.application.shift.shift_type))])]), (_vm.application.shift.comments) ? _c('div', {
    staticClass: "comments"
  }, [_vm._v(_vm._s(_vm.application.shift.comments))]) : _vm._e(), _c('div', {
    staticClass: "answer"
  }, [_c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "button",
    class: _vm.classNA,
    on: {
      "click": function($event) {
        return _vm.applicationResponse('not_available')
      }
    }
  }, [_vm._m(0), _c('br'), _c('span', [_vm._v("Nein")])])]), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "button",
    class: _vm.classYes,
    on: {
      "click": function($event) {
        return _vm.applicationResponse('yes')
      }
    }
  }, [_vm._m(1), _c('br'), _c('span', [_vm._v("Okay")])])]), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "button",
    class: _vm.classAbs,
    on: {
      "click": function($event) {
        return _vm.applicationResponse('absolutely')
      }
    }
  }, [_vm._m(2), _c('br'), _c('span', [_vm._v("Ja")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-meh-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-up"
  })])
}]}

/***/ }),

/***/ 1090:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "presence-panel"
  }, [_c('div', {
    staticClass: "head"
  }, [(_vm.day) ? _c('div', {
    staticClass: "dateDisplay"
  }, [(_vm.user.is_board_member || _vm.user.can_lookup_shift_times) ? _c('div', {
    staticClass: "button dateButton",
    on: {
      "click": function($event) {
        return _vm.changeDate()
      }
    }
  }, [_vm._v("<")]) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.day.date, "DD. MM. YYYY")))]), (_vm.user.is_board_member || _vm.user.can_lookup_shift_times) ? _c('div', {
    staticClass: "button dateButton",
    attrs: {
      "disabled": _vm.isToday
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(true)
      }
    }
  }, [_vm._v(">")]) : _vm._e()]) : _vm._e(), (_vm.day) ? _c('div', {
    staticClass: "events"
  }, [_vm._l((_vm.day.events), function(event) {
    return _c('div', {
      staticClass: "event"
    }, [(!event.canceled) ? [_c('span', [_vm._v(_vm._s(event.badge) + ":")]), _c('span', [_vm._v(" " + _vm._s(event.name))])] : _vm._e()], 2)
  }), (_vm.day.events.length == 0) ? _c('div', [_vm._v("heute keine Veranstaltung")]) : _vm._e()], 2) : _vm._e(), (_vm.day && _vm.day.events.length != 0) ? _c('div', {
    staticClass: "presence-user header"
  }, [_c('div', {
    staticClass: "item"
  }), _vm._m(0), _vm._m(1)]) : _vm._e()]), _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.shifts), function(shift, index) {
    return _c('div', {
      staticClass: "shift-type",
      class: {
        'dark-bg': index % 2
      }
    }, [_c('presence-list', {
      attrs: {
        "shift": shift,
        "user": _vm.user
      },
      on: {
        "refresh": function($event) {
          return _vm.loadShifts()
        }
      }
    })], 1)
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Start")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Ende")])])
}]}

/***/ }),

/***/ 1094:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_hello__ = __webpack_require__(203);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var DEBUG = "production" === 'development';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    hello: __WEBPACK_IMPORTED_MODULE_2__modules_hello__["a" /* default */]
  },
  strict: DEBUG,
  state: {
    user: null
  }
}));

/***/ }),

/***/ 179:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(269)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(1083),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(275)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(1089),
  /* scopeId */
  "data-v-d9571eac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(270)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(1084),
  /* scopeId */
  "data-v-4a35748e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(265)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(1079),
  /* scopeId */
  "data-v-1522c9c6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(264)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(1078),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(272)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(1086),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(267)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(1081),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(276)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(1090),
  /* scopeId */
  "data-v-f4147fba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(271)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(1085),
  /* scopeId */
  "data-v-5169af48",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(266)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(1080),
  /* scopeId */
  "data-v-15c58447",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(273)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(1087),
  /* scopeId */
  "data-v-7d96c573",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(268)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(1082),
  /* scopeId */
  "data-v-38ed8a10",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* harmony default export */ __webpack_exports__["a"] = ({
  getWorld: function getWorld() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      return setTimeout(function () {
        return resolve('world');
      }, 1000);
    });
  }
});

/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_touch__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_localstorage__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Application_vue__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Application_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Application_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Applications_vue__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Applications_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Applications_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PlannedDay_vue__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PlannedDay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_PlannedDay_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_PresencePanel_vue__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_PresencePanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_PresencePanel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_PresenceEntry_vue__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_PresenceEntry_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_PresenceEntry_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_PresenceList_vue__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_PresenceList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_PresenceList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_EmployeesList_vue__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_EmployeesList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_EmployeesList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Shifts_vue__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Shifts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Shifts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Shift_vue__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Shift_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Shift_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Vacations_vue__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Vacations_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Vacations_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Vacation_vue__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Vacation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Vacation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_superagent__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_moment__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment_locale_de__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment_locale_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_moment_locale_de__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_blu__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_blu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_blu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_blu_dist_css_vue_blu_min_css__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_blu_dist_css_vue_blu_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_blu_dist_css_vue_blu_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_simple_spinner__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store__ = __webpack_require__(177);

__webpack_require__(178);


























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('spinner', __WEBPACK_IMPORTED_MODULE_22_vue_simple_spinner___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('icon', __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('application', __WEBPACK_IMPORTED_MODULE_6__components_Application_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('applications', __WEBPACK_IMPORTED_MODULE_7__components_Applications_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('shift', __WEBPACK_IMPORTED_MODULE_14__components_Shift_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('shifts', __WEBPACK_IMPORTED_MODULE_13__components_Shifts_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('vacations', __WEBPACK_IMPORTED_MODULE_15__components_Vacations_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('vacation', __WEBPACK_IMPORTED_MODULE_16__components_Vacation_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('planned-day', __WEBPACK_IMPORTED_MODULE_8__components_PlannedDay_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('employees-list', __WEBPACK_IMPORTED_MODULE_12__components_EmployeesList_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('presence-panel', __WEBPACK_IMPORTED_MODULE_9__components_PresencePanel_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('presence-entry', __WEBPACK_IMPORTED_MODULE_10__components_PresenceEntry_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('presence-list', __WEBPACK_IMPORTED_MODULE_11__components_PresenceList_vue___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_touch___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_blu___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vue_moment___default.a);

var host = window.location.hostname;
if (host === 'schichtplan.pepperz.de') {
  host = 'salat.pepperz.de';
}
if (host === 'schichtplan.yaamxso36.de') {
  host = 'salat.yaamxso36.de';
}
if (host === 'schichtplantest.pepperz.de') {
  host = 'salatverkostung.pepperz.de';
}

var apiUrl = window.location.protocol + '//' + host;
if (window.location.hostname === 'localhost' || window.location.hostname.startsWith('192.')) {
  apiUrl += ':8000';
}
var apiHost = apiUrl;
apiUrl += '/api';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vue_superagent___default.a, {
  baseUrl: apiUrl
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_localstorage___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('starttime', function (value) {
  var vals = value.split(':');
  return vals[0] + ':' + vals[1] + ' Uhr';
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('linebreaks', function (text) {
  return text.replace(/\n/g, '<br/>');
});

if (!Date.prototype.toISODate) {
  Date.prototype.toISODate = function () {
    return this.getFullYear() + '-' + ('0' + (this.getMonth() + 1)).slice(-2) + '-' + ('0' + this.getDate()).slice(-2);
  };
}

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  localStorage: {
    loginToken: {
      type: String
    }
  },
  template: '<App ref="app"/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },
  methods: {
    getLoginToken: function getLoginToken() {
      if (this.$refs['app']) {
        return this.$refs.app.loginToken;
      } else {
        return 'undefined';
      }
    }
  },
  store: __WEBPACK_IMPORTED_MODULE_23__store__["a" /* default */],
  data: {
    apiHost: apiHost
  }
});

/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HELLO_WORLD; });
var HELLO_WORLD = 'HELLO_WORLD';

/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return helloWorld; });
var helloWorld = 'helloWorld';

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_hello__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actionTypes__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getterNames__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutationTypes__ = __webpack_require__(204);








var state = {
  hello: 'world'
};

var getters = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_5__getterNames__["a" /* helloWorld */], function (state, getters) {
  return state.hello;
});

var actions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_4__actionTypes__["a" /* HELLO_WORLD */], function (_ref) {
  var _this = this;

  var commit = _ref.commit,
      getters = _ref.getters,
      state = _ref.state;
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = commit;
            _context.t1 = __WEBPACK_IMPORTED_MODULE_6__mutationTypes__["a" /* HELLO */];
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_3__api_hello__["a" /* default */].getWorld();

          case 4:
            _context.t2 = _context.sent;
            (0, _context.t0)(_context.t1, _context.t2);

          case 6:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }))();
});

var mutations = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_6__mutationTypes__["a" /* HELLO */], function (state, world) {
  state.hello = world;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HELLO; });
var HELLO = 'HELLO';

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);



var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.name && this.$children.length === 0) {
      console.warn('Invalid prop: prop "name" is required.');
      return;
    }

    if (this.icon) {
      return;
    }

    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;

      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      apiUrl: '',
      confirmed: false,
      showApplications: false,
      showEmployeeList: false,
      showVacations: false,
      showShiftPlan: false,
      showGuestList: false,
      showNews: false,
      news: [],
      editShiftTimes: false,
      loginToken: null,
      username: null,
      password: null,
      user: {},
      plannedDays: [],
      fields: [],
      fieldFilter: null,
      vacations: [],
      currentEvent: undefined,
      guests: [],
      guestSearch: '',
      selectedGuest: null,
      guestListTimer: null,
      icons: {
        'band': 'fa-music',
        'so36': 'fa-beer',
        'agency': 'fa-briefcase',
        'win': 'fa-trophy'
      },
      catSearch: ''
    };
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.guestListTimer);
  },

  methods: {
    updateGuest: function updateGuest(guest) {
      console.log('updating guest', guest);
      this.$http.patch('/guest-list-entries/' + guest.id + '/', guest).set({ Authorization: 'jwt ' + this.loginToken }).then(function () {});
    },
    loadNews: function loadNews() {
      var _this = this;

      this.showNews = true;
      this.$http.get('/news/').set({ Authorization: 'jwt ' + this.loginToken }).then(function (response) {
        var news = response.body;

        var oldNewsItems = _this.$localStorage.get('newsItems') || [];

        if (Array.isArray(_this.news)) {
          news.forEach(function (item) {
            item.showContent = !oldNewsItems.includes(item.id);
          });
        }
        _this.news = news;

        var newsIds = news.map(function (item) {
          return item.id;
        });
        _this.$localStorage.set('newsItems', newsIds);
      });
    },

    selectGuest: function selectGuest(guest) {
      this.selectedGuest = this.selectedGuest ? null : guest;
    },
    setCatSearch: function setCatSearch(cat) {
      if (this.catSearch === cat) {
        this.catSearch = '';
      } else {
        this.catSearch = cat;
      }
    },
    loginAs: function loginAs(token) {
      this.loginToken = token;
      this.loginUser();
      window.location.reload();
    },
    displayShiftPlan: function displayShiftPlan() {
      this.showShiftPlan = true;
      var app = this;
      setTimeout(function () {
        var daHin = document.getElementById('plan-starts-today');
        if (daHin) {
          var wieWeit = void 0;
          if (app.canViewAll) {
            wieWeit = daHin.offsetTop - 90;
          } else {
            wieWeit = daHin.offsetTop - 70;
          }
          daHin.parentNode.scrollTop = wieWeit;
        }
      }, 100);
    },
    displayVacations: function displayVacations() {
      this.showVacations = true;
    },
    displayGuestList: function displayGuestList() {
      var _this2 = this;

      this.showGuestList = true;
      this.$http.get('/current-event/').set({ Authorization: 'jwt ' + this.loginToken }).then(function (res) {
        _this2.currentEvent = res.body;
      }).catch(function (err) {
        console.log(err);
      });
      this.$http.get('/guest-list-entries/').set({ Authorization: 'jwt ' + this.loginToken }).then(function (res) {
        _this2.guests = res.body;
      }).catch(function (err) {
        console.log(err);
      });
      this.startGuestListTimer();
    },
    startGuestListTimer: function startGuestListTimer() {
      var _this3 = this;

      this.guestListTimer = setTimeout(function () {
        _this3.loadGuestListEntries();

        _this3.startGuestListTimer();
      }, 30000);
    },

    loadGuestListEntries: function loadGuestListEntries() {
      var _this4 = this;

      this.$http.get('/guest-list-entries/').set({ Authorization: 'jwt ' + this.loginToken }).then(function (res) {
        _this4.guests = res.body;
      }).catch(function (err) {
        console.log(err);
      });
    },
    switchToApplications: function switchToApplications() {
      this.showApplications = true;
    },
    changePanel: function changePanel(direction) {
      if (direction === 'left') {
        if (this.showVacations) {
          this.showVacations = false;
        } else {
          this.showApplications = true;
        }
      } else {
        if (this.showApplications) {
          this.showApplications = false;
        } else {
          this.showVacations = true;
        }
      }
    },
    swipeLeft: function swipeLeft() {
      this.changePanel('right');
    },
    swipeRight: function swipeRight() {
      this.changePanel('left');
    },
    loginUser: function loginUser() {
      var _this5 = this;

      this.$localStorage.set('loginToken', this.loginToken);
      this.$http.get('/current-user/').set({ Authorization: 'jwt ' + this.loginToken }).then(function (res) {
        _this5.user = res.body;
        _this5.getPlannedDays();
        _this5.loadFields();
        _this5.loadVacations();
      }).catch(function (err) {
        _this5.$notify.danger({ content: 'Bitte einloggen!' });
        console.log(err);
      });
    },
    logMeIn: function logMeIn() {
      var _this6 = this;

      if (!this.confirmed) return;

      this.$http.post('/token-get/').accept('json').send({
        username: this.username.toLowerCase(),
        password: this.password
      }).then(function (res) {
        _this6.loginToken = res.body.token;
        _this6.loginUser();
      }).catch(function (err) {
        console.log(err.response.body);
        _this6.$notify.danger({ content: 'Login fehlgeschlagen!' });
      });
    },
    logout: function logout() {
      this.loginToken = undefined;
      this.$localStorage.set('loginToken', undefined);
    },
    getPlannedDays: function getPlannedDays(filterId) {
      var _this7 = this;

      if (this.user.can_view_shift_plan) {
        this.fieldFilter = filterId;

        if (!filterId && this.fields.length === 1) {
          this.fieldFilter = this.fields[0].id;
        }

        var url = '/planned-days/';

        if (this.fieldFilter) {
          url += '?field_id=' + this.fieldFilter;
        }

        this.$http.get(url).set({ Authorization: 'jwt ' + this.loginToken }).then(function (res) {
          _this7.plannedDays = res.body;
        }).catch(function (err) {
          _this7.$notify.danger({ content: 'Der Plan konnte nicht geladen werden!' });
          console.log(err);
        });
      }
    },
    loadVacations: function loadVacations() {
      var _this8 = this;

      this.$http.get('/vacations/?year=' + new Date().getFullYear()).set({ Authorization: 'jwt ' + this.loginToken }).then(function (res) {
        _this8.vacations = res.body;
      }).catch(function (err) {
        console.log(err);
        _this8.$notify.danger('Urlaubsfehler');
      });
    },
    loadFields: function loadFields() {
      var _this9 = this;

      this.$http.get('/fields/').set({ Authorization: 'jwt ' + this.loginToken }).then(function (res) {
        _this9.fields = res.body;
        _this9.getPlannedDays();
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  computed: {
    loggedIn: function loggedIn() {
      return this.loginToken !== undefined;
    },
    canViewAll: function canViewAll() {
      return this.fields.length > 1;
    },
    filteredGuests: function filteredGuests() {
      var _this10 = this;

      return this.guests.filter(function (guest) {
        var categoryMatch = _this10.catSearch ? guest.category === _this10.catSearch : true;

        var nameMatch = guest.name.toLowerCase().includes(_this10.guestSearch.toLowerCase());
        return categoryMatch && nameMatch;
      });
    }
  },
  created: function created() {
    var _this11 = this;

    this.loginToken = this.$localStorage.get('loginToken');

    this.$http.post('/token-verify/').send({ token: this.loginToken }).accept('json').then(function (res) {}).catch(function () {
      _this11.loginToken = undefined;
      _this11.$localStorage.set('loginToken', undefined);
    });
    if (this.loginToken) {
      this.loginUser();
    }

    var host = window.location.hostname;
    if (host === 'schichtplan.pepperz.de') {
      host = 'salat.pepperz.de';
    }
    if (host === 'schichtplan.yaamxso36.de') {
      host = 'salat.yaamxso36.de';
    }
    if (host === 'schichtplantest.pepperz.de') {
      host = 'salatverkostung.pepperz.de';
    }

    var apiUrl = window.location.protocol + '//' + host;
    if (window.location.hostname === 'localhost' || window.location.hostname.startsWith('192.')) {
      apiUrl += ':8000';
    }
    this.apiUrl = apiUrl;
  }
});

/***/ }),

/***/ 207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'application',
  props: ['application'],
  data: function data() {
    return {};
  },

  methods: {
    applicationResponse: function applicationResponse(response) {
      var _this = this;

      var url = '/shift-preference/' + this.application.shift.id + '/0/' + response;
      var app = this;
      this.$http.get(url).set({ Authorization: 'jwt ' + this.$root.$refs.app.loginToken }).then(function (res) {
        _this.application.answer = response;
      }).catch(function (err, data) {
        app.$notify.danger({ content: err.response.body.message });
      });
    },
    checkAnswer: function checkAnswer(answer, classToReturn) {
      if (this.application.answer === '') {
        return classToReturn;
      } else {
        if (this.application.answer === answer) {
          return classToReturn;
        }
      }
    }
  },
  created: function created() {},

  computed: {
    classAbs: function classAbs() {
      return this.checkAnswer('absolutely', 'is-success');
    },
    classYes: function classYes() {
      return this.checkAnswer('yes', 'is-success');
    },
    classNo: function classNo() {
      return this.checkAnswer('no', 'is-warning');
    },
    classNA: function classNA() {
      return this.checkAnswer('not_available', 'is-danger');
    }
  }
});

/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'applications',
  data: function data() {
    return {
      days: []
    };
  },

  methods: {
    applicationResponse: function applicationResponse(application, response) {
      var _this = this;

      var url = '/shift-preference/' + application.shift.id + '/0/' + response;
      console.log(application.shift.event.name + ': ' + application.shift.shift_type);
      console.log(url);
      this.$http.get(url).set({ Authorization: 'jwt ' + this.$root.loginToken }).then(function (res) {
        _this.days = res.body;
      }).catch(function (err) {
        console.log(err);
        _this.$notify.danger({ content: 'Bewerbungsfehler' });
        console.log(err);
      });
    }
  },
  created: function created() {
    this.$nextTick(function () {
      var _this2 = this;

      var loginToken = this.$root.getLoginToken();
      if (loginToken !== 'undefined') {
        this.$http.get('/applications/').set({ Authorization: 'jwt ' + loginToken }).then(function (res) {
          _this2.days = res.body;
        }).catch(function (err) {
          console.log(err);
          _this2.$notify.danger({ content: 'Bewerbungsfehler' });
          console.log(err);
        });
      }
    });
  }
});

/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EmployeesList',
  props: ['fields', 'user'],
  data: function data() {
    return {
      employees: {}
    };
  },

  methods: {
    loginAs: function loginAs(userId) {
      var _this = this;

      var loginToken = this.$parent.$parent.loginToken;
      this.$http.get('/login-as-user/' + userId).set({ Authorization: 'jwt ' + loginToken }).then(function (response) {
        _this.$emit('login-as', response.body.token);
      });
    }
  },
  watch: {
    fields: function fields(newFields, oldFields) {
      var _this2 = this;

      var app = this;
      var loginToken = this.$parent.$parent.loginToken;

      var _loop = function _loop(field) {
        _this2.$http.get('/users/?shift_types__field=' + field.id).set({ Authorization: 'jwt ' + loginToken }).then(function (response) {
          var newData = {};
          newData[field.name] = response.body;
          app.employees = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, app.employees, newData);
        });
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.fields), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var field = _step.value;

          _loop(field);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }
});

/***/ }),

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PlannedDay',
  props: ['day'],
  data: function data() {
    return {};
  },

  methods: {},
  created: function created() {}
});

/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'presence-entry',
  props: ['shiftTime', 'user'],
  data: function data() {
    return {
      loginToken: this.$localStorage.get('loginToken')
    };
  },

  methods: {
    checkin: function checkin() {
      var _this = this;

      this.$http.put(this.baseURL + 'checkin/').set({ Authorization: 'jwt ' + this.loginToken }).then(function (res) {
        _this.$emit('refresh');
      }).catch(function (err, data) {
        console.log(err, data);
      });
    },
    checkout: function checkout() {
      var _this2 = this;

      this.$http.put(this.baseURL + 'checkout/').set({ Authorization: 'jwt ' + this.loginToken }).then(function (res) {
        _this2.$emit('refresh');
      }).catch(function (error) {
        if (error.response.status === 400) {
          var errorMessage = error.response.body['__all__'][0];
          _this2.$notify.danger({ content: errorMessage });
        } else console.log(error);
      });
    },
    add: function add(name, hour) {
      var _this3 = this;

      this.$http.put(this.baseURL + 'add-to-' + name + '/' + (hour ? '?hour=true' : '')).set({ Authorization: 'jwt ' + this.loginToken }).then(function (res) {
        _this3.$emit('refresh');
      }).catch(function (error) {
        if (error.response.status === 400) {
          var errorMessage = error.response.body['__all__'][0];
          _this3.$notify.danger({ content: errorMessage });
        } else console.log(error);
      });
    },
    subtract: function subtract(name, hour) {
      var _this4 = this;

      this.$http.put(this.baseURL + 'subtract-from-' + name + '/' + (hour ? '?hour=true' : '')).set({ Authorization: 'jwt ' + this.loginToken }).then(function (res) {
        _this4.$emit('refresh');
      }).catch(function (err, data) {
        console.log(err);
      });
    }
  },
  created: function created() {},

  computed: {
    baseURL: function baseURL() {
      return '/all-shift-times/' + this.shiftTime.id + '/';
    }
  }
});

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_autosuggest__ = __webpack_require__(291);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'presence-list',
  props: ['shift', 'user'],
  components: {
    VueAutosuggest: __WEBPACK_IMPORTED_MODULE_0_vue_autosuggest__["a" /* VueAutosuggest */]
  },
  data: function data() {
    return {
      selected: '',
      query: '',
      loginToken: this.$localStorage.get('loginToken'),
      options: [{
        data: []
      }],
      filteredOptions: [],
      inputProps: {
        id: 'autosuggest__input',
        input: this.onInputChange,
        placeholder: '+'
      }
    };
  },

  methods: {
    clickHandler: function clickHandler() {
      this.loading = false;
    },
    bolden: function bolden(text, suggestion) {
      var regex = new RegExp('(' + text + ')', 'gi');

      return suggestion.replace(regex, '<b>$1</b>');
    },
    getEmployeeList: function getEmployeeList() {
      var _this = this;

      this.$http.get('/search-free-employees/?shift=' + this.shift.id).set({ Authorization: 'jwt ' + this.loginToken }).then(function (res) {
        _this.options = res.body;
        _this.filteredOptions = res.body;
      }).catch(function (err, data) {
        console.log(err);
      });
    },
    getValue: function getValue(option) {
      return option.item.short_name;
    },
    clear: function clear() {
      this.$refs.addEmployee.internalValue = '';
      this.selected = undefined;
    },
    clearLetters: function clearLetters() {
      if (!this.selected && this.$refs.addEmployee) {
        this.clear();
      }
    },
    onSelected: function onSelected(option) {
      this.selected = option.item;
      this.query = this.selected.short_name;
    },
    confirmSelection: function confirmSelection() {
      var _this2 = this;

      this.$http.post('/add-employee-to-shift/', { user: this.selected, shift: this.shift.id }).set({ Authorization: 'jwt ' + this.loginToken }).then(function (res) {
        _this2.$emit('refresh');
        _this2.getEmployeeList();
        _this2.clear();
      }).catch(function (err, data) {
        console.log(err);
      });
    },
    onInputChange: function onInputChange(text) {
      if (text === '' || text === undefined) {
        return;
      }

      var filteredData = this.options[0].data.filter(function (item) {
        return item.short_name.toLowerCase().indexOf(text.toLowerCase()) > -1;
      }).slice(0, this.limit);

      this.filteredOptions = [{
        data: filteredData
      }];
    }
  },
  created: function created() {},

  computed: {}
});

/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'presence-panel',
  props: ['user'],
  data: function data() {
    return {
      day: undefined,
      date: new Date(),
      shifts: {},
      loginToken: this.$localStorage.get('loginToken')
    };
  },

  methods: {
    loadShifts: function loadShifts() {
      var _this = this;

      var url = '/shift-times/?date=' + this.date.toISODate();
      this.$http.get(url).set({ Authorization: 'jwt ' + this.loginToken }).then(function (res) {
        _this.shifts = res.body;
      }).catch(function (err, data) {
        console.log(err);
      });
    },
    loadDay: function loadDay() {
      var _this2 = this;

      var url = '/admin/get-day?date=' + this.date.toISODate();
      this.$http.get(url).set({ Authorization: 'jwt ' + this.loginToken }).then(function (res) {
        _this2.day = res.body;
      }).catch(function (err, data) {
        console.log(err);
      });
    },
    changeDate: function changeDate(next) {
      var step = next ? 1 : -1;
      this.date = new Date(this.date.setDate(this.date.getDate() + step));
      this.loadDay();
      this.loadShifts();
    }
  },
  created: function created() {
    this.loadShifts();
    this.loadDay();
  },

  computed: {
    isToday: function isToday() {
      var reference = this.date.toISODate();
      var today = new Date().toISODate();
      return reference === today;
    }
  }
});

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Shift',
  props: ['shift'],
  data: function data() {
    return {
      cancelModalVisible: false,
      switchModalVisible: false,
      shiftCanceled: false,
      switchRequested: false
    };
  },

  methods: {
    showCancelModal: function showCancelModal() {
      this.cancelModalVisible = true;
    },
    showSwitchModal: function showSwitchModal() {
      if (!this.switchRequested) {
        this.switchModalVisible = true;
      } else {
        this.$notify.warning({ content: 'Du hast bereits eine Tauschanfrage gestellt.' });
      }
    },
    switchShifts: function switchShifts() {
      var _this = this;

      var app = this;
      this.$http.post('/switch-request/' + this.shift.id + '/').set({ Authorization: 'jwt ' + this.$root.$refs.app.loginToken }).then(function () {
        app.switchRequested = true;
        _this.$notify.danger({ content: 'Tauschanfrage versendet!' });
      }).catch(function (err) {
        console.log(err.response);
        _this.$notify.danger({ content: err.response.body.message });
      });
    },
    cancelShift: function cancelShift() {
      var _this2 = this;

      var app = this;
      this.$http.post('/cancel-shift/' + this.shift.id + '/').set({ Authorization: 'jwt ' + this.$parent.loginToken }).then(function () {
        app.shiftCanceled = true;
        _this2.$notify.danger({ content: 'Absage versendet!' });
      }).catch(function (err) {
        console.log(err.response);
        _this2.$notify.danger({ content: err.response.body.message });
      });
    }
  },
  created: function created() {}
});

/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'shifts',
  props: ['switchToApplications', 'user'],
  data: function data() {
    return {
      days: [],
      loading: true
    };
  },
  created: function created() {
    this.$nextTick(function () {
      var _this = this;

      var loginToken = this.$parent.loginToken;
      if (loginToken !== 'undefined') {
        this.$http.get('/shifts/').set({ Authorization: 'jwt ' + loginToken }).then(function (res) {
          return _this.days = res.body;
        }).catch(function (err) {
          console.log(err);
          _this.$notify.danger('Keine Shichten');
        });
      }
    });
  },

  methods: {
    toggleOtherShifts: function toggleOtherShifts(day) {
      day.show_others = !day.show_others;
    }
  }
});

/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vacation',
  props: ['vacation', 'user'],
  data: function data() {
    return {
      showConfirmation: false,
      loginToken: this.$localStorage.get('loginToken')
    };
  },

  methods: {
    deleteVacation: function deleteVacation() {
      var _this = this;

      this.$http.delete('/vacations/' + this.vacation.id + '/').set({ Authorization: 'jwt ' + this.loginToken }).accept('json').then(function (res) {
        _this.$emit('reload-vacations');
      }).catch(function () {});
    }
  },
  computed: {
    canDeleteVacation: function canDeleteVacation() {
      var isInTheFuture = new Date(this.vacation.start) > new Date();
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var createdToday = new Date(this.vacation.created) > today;
      return isInTheFuture && (createdToday || this.user.freelancer);
    }
  }
});

/***/ }),

/***/ 217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vacations',
  props: ['vacations', 'user'],
  data: function data() {
    return {
      new_vacation: {
        start: undefined,
        end: undefined
      },
      showOtherVacations: false,
      otherVacations: [],
      loginToken: this.$localStorage.get('loginToken'),
      error: undefined,
      vacationData: {}
    };
  },

  methods: {
    submitVacation: function submitVacation(event) {
      var _this = this;

      this.error = undefined;
      if (!this.new_vacation.start || !this.new_vacation.end) {} else {
        event.preventDefault();
        this.$http.post('/vacations/', this.new_vacation).set({ Authorization: 'jwt ' + this.loginToken }).accept('json').then(function (res) {
          _this.$emit('reload-vacations');
          _this.new_vacation.start = undefined;
          _this.new_vacation.end = undefined;
          _this.new_vacation.used_days = undefined;
          _this.loadVacationData();
        }).catch(function (error, dings) {
          var errorMessage = JSON.parse(error.response.text);
          _this.error = errorMessage.non_field_errors[0];
        });
      }
    },
    setEnd: function setEnd() {
      if (!this.new_vacation.end || this.new_vacation.end < this.new_vacation.start) {
        this.new_vacation.end = this.new_vacation.start;
      }
    },
    loadVacationData: function loadVacationData() {
      var _this2 = this;

      this.$http.get('/calendar/vacationdata/').set({ Authorization: 'jwt ' + this.loginToken }).then(function (res) {
        _this2.vacationData = res.body;
      }).catch(function () {});
    },
    loadOtherVacations: function loadOtherVacations() {
      var _this3 = this;

      this.$http.get('/other-vacations/').set({ Authorization: 'jwt ' + this.loginToken }).then(function (res) {
        _this3.otherVacations = res.body;
      }).catch(function () {});
    }
  },
  created: function created() {
    this.loadVacationData();
    this.loadOtherVacations();
  }
});

/***/ }),

/***/ 264:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 265:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 266:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 267:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 269:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 270:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 271:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 273:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 274:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 275:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 276:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 49,
	"./af.js": 49,
	"./ar": 56,
	"./ar-dz": 50,
	"./ar-dz.js": 50,
	"./ar-kw": 51,
	"./ar-kw.js": 51,
	"./ar-ly": 52,
	"./ar-ly.js": 52,
	"./ar-ma": 53,
	"./ar-ma.js": 53,
	"./ar-sa": 54,
	"./ar-sa.js": 54,
	"./ar-tn": 55,
	"./ar-tn.js": 55,
	"./ar.js": 56,
	"./az": 57,
	"./az.js": 57,
	"./be": 58,
	"./be.js": 58,
	"./bg": 59,
	"./bg.js": 59,
	"./bm": 60,
	"./bm.js": 60,
	"./bn": 61,
	"./bn.js": 61,
	"./bo": 62,
	"./bo.js": 62,
	"./br": 63,
	"./br.js": 63,
	"./bs": 64,
	"./bs.js": 64,
	"./ca": 65,
	"./ca.js": 65,
	"./cs": 66,
	"./cs.js": 66,
	"./cv": 67,
	"./cv.js": 67,
	"./cy": 68,
	"./cy.js": 68,
	"./da": 69,
	"./da.js": 69,
	"./de": 18,
	"./de-at": 70,
	"./de-at.js": 70,
	"./de-ch": 71,
	"./de-ch.js": 71,
	"./de.js": 18,
	"./dv": 72,
	"./dv.js": 72,
	"./el": 73,
	"./el.js": 73,
	"./en-SG": 74,
	"./en-SG.js": 74,
	"./en-au": 75,
	"./en-au.js": 75,
	"./en-ca": 76,
	"./en-ca.js": 76,
	"./en-gb": 77,
	"./en-gb.js": 77,
	"./en-ie": 78,
	"./en-ie.js": 78,
	"./en-il": 79,
	"./en-il.js": 79,
	"./en-nz": 80,
	"./en-nz.js": 80,
	"./eo": 81,
	"./eo.js": 81,
	"./es": 84,
	"./es-do": 82,
	"./es-do.js": 82,
	"./es-us": 83,
	"./es-us.js": 83,
	"./es.js": 84,
	"./et": 85,
	"./et.js": 85,
	"./eu": 86,
	"./eu.js": 86,
	"./fa": 87,
	"./fa.js": 87,
	"./fi": 88,
	"./fi.js": 88,
	"./fo": 89,
	"./fo.js": 89,
	"./fr": 92,
	"./fr-ca": 90,
	"./fr-ca.js": 90,
	"./fr-ch": 91,
	"./fr-ch.js": 91,
	"./fr.js": 92,
	"./fy": 93,
	"./fy.js": 93,
	"./ga": 94,
	"./ga.js": 94,
	"./gd": 95,
	"./gd.js": 95,
	"./gl": 96,
	"./gl.js": 96,
	"./gom-latn": 97,
	"./gom-latn.js": 97,
	"./gu": 98,
	"./gu.js": 98,
	"./he": 99,
	"./he.js": 99,
	"./hi": 100,
	"./hi.js": 100,
	"./hr": 101,
	"./hr.js": 101,
	"./hu": 102,
	"./hu.js": 102,
	"./hy-am": 103,
	"./hy-am.js": 103,
	"./id": 104,
	"./id.js": 104,
	"./is": 105,
	"./is.js": 105,
	"./it": 107,
	"./it-ch": 106,
	"./it-ch.js": 106,
	"./it.js": 107,
	"./ja": 108,
	"./ja.js": 108,
	"./jv": 109,
	"./jv.js": 109,
	"./ka": 110,
	"./ka.js": 110,
	"./kk": 111,
	"./kk.js": 111,
	"./km": 112,
	"./km.js": 112,
	"./kn": 113,
	"./kn.js": 113,
	"./ko": 114,
	"./ko.js": 114,
	"./ku": 115,
	"./ku.js": 115,
	"./ky": 116,
	"./ky.js": 116,
	"./lb": 117,
	"./lb.js": 117,
	"./lo": 118,
	"./lo.js": 118,
	"./lt": 119,
	"./lt.js": 119,
	"./lv": 120,
	"./lv.js": 120,
	"./me": 121,
	"./me.js": 121,
	"./mi": 122,
	"./mi.js": 122,
	"./mk": 123,
	"./mk.js": 123,
	"./ml": 124,
	"./ml.js": 124,
	"./mn": 125,
	"./mn.js": 125,
	"./mr": 126,
	"./mr.js": 126,
	"./ms": 128,
	"./ms-my": 127,
	"./ms-my.js": 127,
	"./ms.js": 128,
	"./mt": 129,
	"./mt.js": 129,
	"./my": 130,
	"./my.js": 130,
	"./nb": 131,
	"./nb.js": 131,
	"./ne": 132,
	"./ne.js": 132,
	"./nl": 134,
	"./nl-be": 133,
	"./nl-be.js": 133,
	"./nl.js": 134,
	"./nn": 135,
	"./nn.js": 135,
	"./pa-in": 136,
	"./pa-in.js": 136,
	"./pl": 137,
	"./pl.js": 137,
	"./pt": 139,
	"./pt-br": 138,
	"./pt-br.js": 138,
	"./pt.js": 139,
	"./ro": 140,
	"./ro.js": 140,
	"./ru": 141,
	"./ru.js": 141,
	"./sd": 142,
	"./sd.js": 142,
	"./se": 143,
	"./se.js": 143,
	"./si": 144,
	"./si.js": 144,
	"./sk": 145,
	"./sk.js": 145,
	"./sl": 146,
	"./sl.js": 146,
	"./sq": 147,
	"./sq.js": 147,
	"./sr": 149,
	"./sr-cyrl": 148,
	"./sr-cyrl.js": 148,
	"./sr.js": 149,
	"./ss": 150,
	"./ss.js": 150,
	"./sv": 151,
	"./sv.js": 151,
	"./sw": 152,
	"./sw.js": 152,
	"./ta": 153,
	"./ta.js": 153,
	"./te": 154,
	"./te.js": 154,
	"./tet": 155,
	"./tet.js": 155,
	"./tg": 156,
	"./tg.js": 156,
	"./th": 157,
	"./th.js": 157,
	"./tl-ph": 158,
	"./tl-ph.js": 158,
	"./tlh": 159,
	"./tlh.js": 159,
	"./tr": 160,
	"./tr.js": 160,
	"./tzl": 161,
	"./tzl.js": 161,
	"./tzm": 163,
	"./tzm-latn": 162,
	"./tzm-latn.js": 162,
	"./tzm.js": 163,
	"./ug-cn": 164,
	"./ug-cn.js": 164,
	"./uk": 165,
	"./uk.js": 165,
	"./ur": 166,
	"./ur.js": 166,
	"./uz": 168,
	"./uz-latn": 167,
	"./uz-latn.js": 167,
	"./uz.js": 168,
	"./vi": 169,
	"./vi.js": 169,
	"./x-pseudo": 170,
	"./x-pseudo.js": 170,
	"./yo": 171,
	"./yo.js": 171,
	"./zh-cn": 172,
	"./zh-cn.js": 172,
	"./zh-hk": 173,
	"./zh-hk.js": 173,
	"./zh-tw": 174,
	"./zh-tw.js": 174
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 279;

/***/ })

},[200]);


// WEBPACK FOOTER //
// static/js/app.93e5e27c93db63aa8f22.js